import { get, post, remove } from "./base";
import store from "../store";
import * as actions from "../store/actions/userProfile";
import url from "./url";
import queries from "./queries";

const { dispatch } = store;

async function getCards({ headers = {} } = {}) {
  try {
    const query = url(queries.stripeCards);
    dispatch(actions.paymentGetCards());
    const response = await get(query, headers);
    dispatch(actions.paymentGetCardsSuccess(response));
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return dispatch(actions.paymentGetCardsFailed(errorData || error));
  }
}

async function addCard({ data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.stripeCards);
    dispatch(actions.paymentAddCard());
    const response = await post(query, data, headers);
    dispatch(actions.paymentAddCardSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.paymentAddCardFailed(err));
  }
}

async function selectCard({ data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.stripeCardsSetDefault);
    dispatch(actions.paymentSelectCard());
    const response = await post(query, data, headers);
    dispatch(actions.paymentSelectCardSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.paymentSelectCardFailed(err));
  }
}

async function removeCard({ data = {}, headers = {} } = {}) {
  try {
    const query = url(`${queries.stripeCards}/${data.id}`);
    dispatch(actions.paymentRemoveCard());
    const response = await remove(query, data, headers);
    dispatch(actions.paymentRemoveCardSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.paymentRemoveCardFailed(err));
  }
}

async function getPayments({ id = "", headers = {} } = {}) {
  try {
    const query = url(queries.stripeCustomers, id);
    dispatch(actions.paymentGetHistory());
    const response = await get(query, headers);
    return dispatch(actions.paymentGetHistorySuccess(response[0].payments));
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.paymentGetHistoryFailed(err));
  }
}

async function getStatistics({ headers = {} } = {}) {
  try {
    const query = url(queries.paymentStatistics);
    dispatch(actions.paymentGetStatistics());
    const response = await get(query, headers);
    return dispatch(actions.paymentGetStatisticsSuccess(response));
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.paymentGetStatisticsFailed(err));
  }
}

export default class paymentsAPI {
  static cards = getCards;

  static addCard = addCard;

  static selectCard = selectCard;

  static removeCard = removeCard;

  static getPayments = getPayments;

  static getStatistics = getStatistics;
}
